var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tr-child"},[_c('v-btn',{class:['icon', {'isClick': _vm.isOpenChild }],attrs:{"icon":"","small":""},on:{"click":_vm.onChild}},[_c('svg-sprite',{attrs:{"width":"20","height":"20","icon-id":"arrow"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }